import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { Avatar, Window } from "../HW";

const ease = [0.2, 0.8, 0.2, 1];
const COLS = [
  ["New", [["Deck & pergola", "Lane Cove · est. $34,000", 92, "JT"], ["Ensuite renovation", "Mosman · est. $28,500", 81, "SM"], ["Blocked sewer", "Sandy Bay · est. $1,800", 44, null]]],
  ["Contacted", [["Commercial refit", "Surry Hills · est. $62,000", 88, "SM"], ["Hot water replacement", "Manly · est. $3,240", 63, "LW"]]],
  ["Quoted", [["24 Smith Street", "Deck & alfresco · $84,500", 95, "SM"], ["Granny flat", "Kellyville · $148,000", 71, "JT"]]],
  ["Won", [["Second-storey addition", "Castle Hill · $286,500", 100, "SM"], ["Switchboard & EV", "Manly · $9,840", 100, "LW"]]],
];

// CRM pipeline with intent scoring — the AI signature appears only where AI has done something.
export default function Crm({ height }) {
  return (
    <Window active="CRM" crumb={<>CRM <span className="font-normal text-[#A1A1AA]">· Leads</span></>} testid="hw-crm" height={height}>
      <div className="flex items-center justify-between px-4 pt-3.5"><div><div className="text-[16px] font-semibold tracking-tight">Leads</div><div className="text-[10.5px] text-[#71717A]">9 open · $658,380 pipeline · 7 high intent not contacted today</div></div><span className="hw-btn amber"><Sparkles size={11} /> Prioritise with AI</span></div>
      <div className="mt-3 grid grid-cols-4 gap-px border-t border-[#ECECEE] bg-[#ECECEE]">
        {COLS.map(([st, cards], ci) => (
          <div key={st} className="min-h-[260px] bg-[#FAFAFB] p-2">
            <div className="hw-label flex items-center justify-between px-1 pb-2">{st}<span className="font-mono">{cards.length}</span></div>
            <div className="space-y-1.5">
              {cards.map(([t, s, score, who], i) => (
                <motion.div key={t} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35, delay: 0.05 * (ci * 3 + i), ease }} className="rounded-md border border-[#ECECEE] bg-white p-2.5">
                  <div className="flex items-center justify-between gap-2"><span className="truncate text-[12px] font-medium">{t}</span>{who && <Avatar n={who} />}</div>
                  <div className="mt-0.5 truncate text-[10.5px] text-[#71717A]">{s}</div>
                  <div className="mt-2 flex items-center gap-1.5"><span className={`h-1 flex-1 overflow-hidden rounded-full bg-[#F1F1F3]`}><span className={`block h-full rounded-full ${score >= 85 ? "bg-amber-500" : "bg-[#0A0A0B]"}`} style={{ width: `${score}%` }} /></span><span className={`text-[10px] font-semibold ${score >= 85 ? "text-amber-700" : "text-[#71717A]"}`}>{score >= 85 ? "High intent" : score === 100 ? "Won" : `${score}`}</span></div>
                </motion.div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Window>
  );
}
